<template>
    <ModalBase
        :name="'generar-enlace-pago-' + plazo.id"
        title="Generar enlace de pago"
        @close="handleClose"
    >
        <div class="tw:space-y-4">
            <p class="tw:text-sm tw:text-gray-700">
                Se enviará un correo al abonado con un enlace a su perfil para que pague este plazo.
            </p>

            <div class="tw:bg-gray-50 tw:border tw:border-gray-200 tw:rounded-lg tw:p-4 tw:space-y-2">
                <div class="tw:flex tw:justify-between">
                    <span class="tw:text-sm tw:font-medium tw:text-gray-700">Plazo Nº:</span>
                    <span class="tw:text-sm tw:text-gray-900">{{ plazo.id }}</span>
                </div>
                <div class="tw:flex tw:justify-between">
                    <span class="tw:text-sm tw:font-medium tw:text-gray-700">Importe:</span>
                    <span class="tw:text-sm tw:text-gray-900">{{ plazo.importe | formatear_precio }}</span>
                </div>
            </div>

            <p v-if="plazo.estado === 4" class="tw:text-sm tw:text-red-600 tw:leading-relaxed">
                Mientras el plazo siga impagado, el abono quedará
                <strong>INACTIVO</strong> hasta que se regularice el pago.
            </p>
        </div>

        <template #footer>
            <div class="tw:flex tw:gap-2 tw:justify-end">
                <Button variant="border" @click="handleClose">
                    Cancelar
                </Button>
                <Button variant="primary" @click="handleConfirm">
                    Enviar enlace
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { getCurrentInstance } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        plazo: {
            type: Object,
            required: true
        }
    })

    const emit = defineEmits(['generar-enlace-pago', 'close'])

    const instance = getCurrentInstance()

    const handleConfirm = () => {
        emit('generar-enlace-pago', props.plazo.id)
        handleClose()
    }

    const handleClose = () => {
        instance.proxy.$modal.hide('generar-enlace-pago-' + props.plazo.id)
        emit('close')
    }
</script>
